import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';

import { BaseWebService } from "../shared/services/base-web.service";
import 'rxjs/add/observable/throw';

@Injectable()
export class ChatMessengerService {
    socket: WebSocket;
    url = "ws://10.7.90.30/ws/?token=";

    constructor(
        private _baseWebService: BaseWebService
    ) {
        // this.socketInitialization();
    }

    // socketInitialization(token: string) {
    //     console.log(token)
    //     this.socket = new WebSocket('ws://10.7.90.30/ws/?token=c5469a432dc9abb42246586da894c1f4a534899b');
    //     this.socket.onopen = e => {
    //         console.log('open');
    //     };
    //     this.socket.onclose = (evt: any) => {
    //         console.log("CLOSED");
    //     };
    //     this.socket.onmessage = (evt: any) => {

    //         console.log(evt);
    //     };
    //     this.socket.onerror = (evt: any) => {
    //         console.log("ERROR: ", evt);
    //     };
    //     // setTimeout(() => {
    //     //   this.timeout();
    //     // }, 110000);
    // }

    getChatPeople(offset: any, limit: any) {
        return this._baseWebService.request("v1/chat/rooms/?offset=" + offset + "&limit=" + limit, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    getMessageRoomDetails(id: any) {
        return this._baseWebService.request("v1/chat/rooms/" + id + "/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    resendInvitaion(id: any, reqData: any) {
        const data: any = {};
        data.body = reqData;
        return this._baseWebService.request("v1/chat/rooms/" + id + "/", "put", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    getMessagePeople(id: any, offset: any, limit: any) {
        return this._baseWebService.request("v1/chat/rooms/" + id + "/message/?offset=" + offset + "&limit=" + limit, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    searchChatPeople(searchKey: any) {
        return this._baseWebService.request("v1/chat/search/?search=" + searchKey + "&offset=0&limit=50", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    createGroup(reqData: any) {
        const data: any = {};
        reqData.type = 'group';
        data.body = reqData;
        return this._baseWebService.request("v1/chat/rooms/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    removeMember(groupId: any, reqData: any) {
        const data: any = {};
        data.body = reqData;
        return this._baseWebService.request("v1/chat/rooms/" + groupId + "/member/", "delete", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    removePhoneNo(groupId: any, phoneId: any) {
        return this._baseWebService.request("v1/chat/rooms/" + groupId + "/phone/" + phoneId + "/", "delete")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    addMemberToGroup(groupId: any, reqData: any) {
        const data: any = {};
        data.body = reqData;
        return this._baseWebService.request("v1/chat/rooms/" + groupId + "/member/", "put", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    addPhoneNoToGroup(groupId: any, reqData: any) {
        const data: any = {};
        data.body = reqData;
        return this._baseWebService.request("v1/chat/rooms/" + groupId + "/phone/" , "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    startNewChat(reqData: any, chatOpenFrom: any) {
        const data: any = {};
        reqData.type = 'direct';
        if (chatOpenFrom === 'follow_up') {
            reqData.followup_type = 'consultation_followup';
        } else if (chatOpenFrom === 'patient_referral') {
            reqData.followup_type = 'patient_referral_followup';
        } else if (chatOpenFrom === 'parent_relapse') {
            reqData.followup_type = 'parent_ortho_followup';
        } else if (chatOpenFrom === 'patient_relapse') {
            reqData.followup_type = 'patient_ortho_followup';
        } else if (chatOpenFrom === 'vc_follow_up') {
            reqData.followup_type = 'virtual_consultation_followup';
        } else if (chatOpenFrom === 'non_start_followup') {
            reqData.followup_type = 'non_start_tracking_followup';
        }
        data.body = reqData;
        return this._baseWebService.request("v1/chat/rooms/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    uploadPhoto(reqData: any, room_id: any) {
        const data: any = {};
        data.body = reqData;
        return this._baseWebService.requestFormData("v1/chat/rooms/" + room_id + "/message/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    acceptInvitation(id: any, reqData: any) {
        const data: any = {};
        data.body = reqData;
        return this._baseWebService.requestFormData("v1/chat/rooms/" + id + "/approve/", "put", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Function for handling service call errors
     * @param  {Response|any} error contains error data
     */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }
}